module.exports = __webpack_public_path__ + "img/content11.fe7ad695.png";